import { Injectable } from '@angular/core';
import { BehaviorSubject, filter, take, tap } from 'rxjs';

export interface ModalConfig {
  isOpen?: boolean;
  event?: {
    isConfirm: boolean
  };
  content?: {
    title: string;
    content: string;
    contentImg?:boolean;
    imgSrc:string;
    closeButtonText: string;
    closeButtonbg?:string;
    closeButtonColor?:string,
    redirectionUrl?:string
    saveButtonText: string;
    isCloseButtonVisible: boolean;
    isSaveButtonVisible: boolean;
    showButtonImg:boolean;
    closeButtonHover?:string;
    saveButtonColor?:string
    saveButtonHover?:string
  };
}

export interface ModalContent{
  title: string;
  content: string;
  contentImg?:boolean;
  imgSrc:string;
  closeButtonText: string;
  closeButtonbg?:string;
  closeButtonColor?:string,
  redirectionUrl?:string
  saveButtonText?: string;
  isCloseButtonVisible?: boolean;
  isSaveButtonVisible?: boolean;
  showButtonImg?:boolean;
  closeButtonHover?:string;
  saveButtonColor?:string;
  saveButtonHover?:string

}

@Injectable({
  providedIn: 'root'
})
export class ConfirmationModalService {

  modalConfigSubject = new BehaviorSubject<ModalConfig>({
    isOpen: false,
    content: {
      title: '',
      content: '',
      imgSrc:'',
      closeButtonText: '',
      redirectionUrl:'',
      closeButtonbg:'',
      closeButtonColor:'',
      saveButtonText: '',
      isCloseButtonVisible: true,
      isSaveButtonVisible: true,
      showButtonImg:false,
      closeButtonHover:'',
      saveButtonColor:'',
      saveButtonHover:''
    }
  });
  modalConfig$ = this.modalConfigSubject.asObservable();

  openModal(config: ModalConfig) {
    this.modalConfigSubject.next({
      ...this.modalConfigSubject.value,
      ...config,
      isOpen: true
    });

    return this.modalConfig$.
      pipe(
        filter((res) => res.hasOwnProperty('event')),
        take(1),
        tap(() => this.modalConfigSubject.next({isOpen: false}))
      );
  }

  closeModal() {
    this.modalConfigSubject.next({...this.modalConfigSubject.value, isOpen: false
    });
  }

}
